import React, { useCallback, useMemo } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'

import { SubMenu } from '../components'
import { Paths } from '../config/routes'
import { AccountsContextProvider } from '../contexts/accounts-page-context'
import { useUser } from '../contexts/user/user-context'
import { useFeatureFlags } from '../hooks/use-feature-flags'
import { Accounts } from '../pages/acconts'
import { DashboardHub } from '../pages/dashboard-hub'
import { DataFarming, DataFarmingTable } from '../pages/data-farming'
import { DemoSettings } from '../pages/demo-settings'
import { ConnectedInvestorDashboard } from '../pages/investor-dashboard/connected-investor-dashboard'
import { LiquidityProvider } from '../pages/liquidity-provider'
import { Loan } from '../pages/loan'
import { LoanApplications } from '../pages/loan-applications/loan-applications'
import { Loans } from '../pages/loans'
import { LoansHistory } from '../pages/loans-history'
import { PoolDashboard } from '../pages/pool-dashboard'
import { ReviewLoanApplication } from '../pages/review-loan-application'
import { StakeDashboard } from '../pages/stake-dashboard'

export function DashboardRouter() {
    const history = useHistory()
    const location = useLocation()
    const { hasFeature, loading: loadingFeatures } =
        useFeatureFlags('demo_settings')
    const { userProfile } = useUser()

    const handlePath = useCallback(
        (path: string) => history.push(path),
        [history],
    )

    const role = useMemo(() => {
        //@ts-ignore
        const profile = userProfile?.getUserProfile
        const role = profile?.activeRole
        return role ?? 'INDIVIDUAL'
    }, [userProfile])

    const subMenuOptions = useMemo(() => {
        let menuItems = [
            {
                children: 'Dashboard',
                selected: location.pathname.includes(Paths.DASHBOARD),
                onClick: () => handlePath(Paths.DASHBOARD),
            },
            {
                children: 'Accounts',
                selected: location.pathname.includes(Paths.ACCOUNTS),

                onClick: () => handlePath(Paths.ACCOUNTS),
            },
            {
                children: 'Data Farming',
                selected:
                    location.pathname.includes(Paths.DATA_FARMING) ||
                    location.pathname.includes(Paths.DATA_FARMING_TABLE),

                onClick: () => {
                    handlePath(Paths.DATA_FARMING)
                },
            },
            {
                children: 'Liquidity Provider',
                selected: location.pathname.includes(Paths.LIQUIDITY_PROVIDER),

                onClick: () => handlePath(Paths.LIQUIDITY_PROVIDER),
            },
        ]

        if (!loadingFeatures && hasFeature) {
            menuItems.push({
                children: 'Demo settings',
                selected: location.pathname.includes(Paths.DEMO_SETTINGS),

                onClick: () => handlePath(Paths.DEMO_SETTINGS),
            })
        }

        if (userProfile) {
            //@ts-ignore
            const profile = userProfile.getUserProfile
            const role = profile.activeRole

            switch (role) {
                case null:
                case 'INDIVIDUAL':
                    menuItems = [
                        ...menuItems,
                        // {
                        //     children: 'Loans',
                        //     selected:
                        //         location.pathname.includes('/loans/') ||
                        //         location.pathname.includes('/loan'),

                        //     onClick: () => handlePath(Paths.LOANS),
                        // },
                    ]
                    break
                case 'BUSINESS':
                    menuItems = [
                        ...menuItems,
                        // {
                        //     children: 'Loans',
                        //     selected:
                        //         location.pathname.includes('/loans/') ||
                        //         location.pathname.includes('/loan'),

                        //     onClick: () => handlePath(Paths.LOANS),
                        // },
                    ]
                    break
                case 'VALIDATOR':
                    menuItems = [
                        ...menuItems,
                        {
                            children: 'Stake',
                            selected: location.pathname.includes(Paths.STAKE),
                            onClick: () => handlePath(Paths.STAKE),
                        },
                    ]
            }
        }

        return menuItems
    }, [handlePath, location, userProfile, loadingFeatures, hasFeature])

    if (!role) return <></>
    return (
        <>
            <div
                className='flex flex-col w-full px-4 py-4 lg:px-24'
                style={{ height: '89vh' }}>
                <SubMenu options={subMenuOptions} />
                <Switch>
                    <Route path={Paths.REVIEW_LOAN_APPLICATION}>
                        <ReviewLoanApplication />
                    </Route>
                    <Route path={Paths.STAKE}>
                        <StakeDashboard />

                        {/* <h2 className="mt-8">Coming soon...</h2> */}
                    </Route>
                    <Route path={Paths.LOAN_APPLICATIONS}>
                        <LoanApplications />
                    </Route>
                    <Route path={Paths.DASHBOARD}>
                        <DashboardHub />
                    </Route>
                    <Route path={Paths.DATA_FARMING}>
                        <DataFarming />
                    </Route>
                    <Route path={Paths.DATA_FARMING_TABLE}>
                        <DataFarmingTable />
                    </Route>
                    <Route path={Paths.LENDING_POOLS}>
                        <ConnectedInvestorDashboard />
                    </Route>
                    <Route path={Paths.LENDING_POOL}>
                        <PoolDashboard />
                    </Route>
                    <Route path={Paths.LOAN}>
                        <Loan />
                    </Route>
                    <Route path={Paths.LOANS_HISTORY}>
                        <LoansHistory />
                    </Route>
                    <Route path={Paths.LOANS}>
                        <Loans />
                    </Route>
                    <Route path={Paths.LIQUIDITY_PROVIDER}>
                        <LiquidityProvider />
                    </Route>
                    {!loadingFeatures && hasFeature && (
                        <Route path={Paths.DEMO_SETTINGS}>
                            <DemoSettings />
                        </Route>
                    )}

                    <Route path={Paths.ACCOUNTS}>
                        <AccountsContextProvider>
                            <Accounts />
                        </AccountsContextProvider>
                    </Route>
                    <Route path={Paths.REWARDS}>
                        <div className='py-6'>
                            <h2>Coming soon...</h2>
                        </div>
                    </Route>
                </Switch>
            </div>
        </>
    )
}
